<template>
  <div id="app">
    <router-view class="app" />
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family:
    "Helvetica Neue",
    Helvetica,
    "PingFang SC",
    "Hiragino Sans GB",
    "Microsoft YaHei",
    "微软雅黑",
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

.el-message__group {
  min-height: 20px;
  height: auto;

  p {
    white-space: pre-line;
    word-break: break-all;
  }
}

.el-switch {
  position: relative;
  top: -1px;
}

.el-button {
  [class*=" el-icon-"],
  [class^=el-icon-] {
    vertical-align: top;
  }
}

.el-input__inner {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/App.vue